module.exports = __webpack_public_path__ + "img/work-plan-days.ef66c75f.svg";